import { Link } from '@skooldio/skooldio-ui-components-core';

export default Link;
